import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignTopContentCreatorsLoadFulfilledAction } from '../../domains/campaignTopContentCreators/actions.types';
import { CampaignTopThreadsLoadFulfilledAction } from '../../domains/campaignTopThreads/actions.types';
import { CreateEventFulfilledAction } from '../../domains/createEvent/actions.types';
import { EditEventFulfilledAction } from '../../domains/editEvent/actions.types';
import { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';
import { EventLoadByBroadcastIdFulfilledAction } from '../../domains/eventLoadByBroadcastId/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import { FirstRunSuggestedGroupsLoadFulfilledAction } from '../../domains/firstRunSuggestedGroups/actions.types';
import { GroupMemberSearchLoadFulfilledAction } from '../../domains/groupMemberSearch/actions.types';
import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';
import {
  GroupSuggestedMembersLoadAction,
  GroupSuggestedMembersLoadMoreAction,
} from '../../domains/groupSuggestedMembers/actions.types';
import { GroupsMembersLoadFulfilledAction } from '../../domains/groupsMembers/actions.types';
import {
  LeaderLoadFulfilledAction,
  UserConnectedLeadersListLoadFulfilledAction,
  UserDirectAudienceLoadFulfilledAction,
  UserDirectAudienceLoadMoreFulfilledAction,
  UserFollowedLeadersListLoadFulfilledAction,
  UserFollowedLeadersListLoadMoreFulfilledAction,
  UserNetworkLeadersListLoadFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';
import { LiveEventLoadByGroupIdFulfilledAction } from '../../domains/liveEventLoadByGroupId/actions.types';
import { MessageReactionsLoadFulfilledAction } from '../../domains/messageReactions/actions.types';
import {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/types';
import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import { NetworkTopAnnouncementsLoadFulfilledAction } from '../../domains/networkTopAnnouncements/actions.types';
import { NetworkTopThreadStartersLoadAction } from '../../domains/networkTopThreadStarters/actions.types';
import { NetworkTopThreadsLoadFulfilledAction } from '../../domains/networkTopThreads/actions.types';
import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';
import {
  OfficialGroupsLoadFulfilledAction,
  OfficialGroupsLoadMoreFulfilledAction,
} from '../../domains/officialGroups/actions.types';
import {
  ThreadPinToEventFeedFulfilledAction,
  ThreadPinToGroupFeedFulfilledAction,
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromEventFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../domains/pinnedThreads/actions.types';
import {
  PublishDirectMessageFulfilledAction,
  PublishEditMessageFulfilledAction,
  PublishEventMessageFulfilledAction,
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
  PublishTeamsMeetingMessageFulfilledAction,
  PublishUserMessageFulfilledAction,
  PublishUserMomentMessageFulfilledAction,
  PublishUserPollMessageFulfilledAction,
  PublishUserPraiseMessageFulfilledAction,
} from '../../domains/publishers/actions.types';
import {
  RecommendedGroupsLoadFulfilledAction,
  RecommendedGroupsLoadMoreFulfilledAction,
} from '../../domains/recommendedGroups/actions.types';
import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import {
  SecondLevelRepliesLoadLastFulfilledAction,
  SecondLevelRepliesLoadNextFulfilledAction,
  SecondLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/secondLevelReplies/actions.types';
import { SessionLoadCurrentUserFulfilledAction } from '../../domains/sessionLoadCurrentUser/actions.types';
import { SuggestedActionsLoadFulfilledAction } from '../../domains/suggestedActions/actions.types';
import {
  SuggestedGroupsLoadFulfilledAction,
  SuggestedGroupsLoadMoreFulfilledAction,
} from '../../domains/suggestedGroups/actions.types';
import { SuggestedLeadersLoadFulfilledAction } from '../../domains/suggestedLeaders/actions.types';
import { SuggestedLeadersLoadMoreFulfilledAction } from '../../domains/suggestedLeaders/loadMoreActions.types';
import { SuggestedMyLeaderGroupsLoadFulfilledAction } from '../../domains/suggestedMyLeaderGroups/actions.types';
import { SuggestedUsersLoadFulfilledAction } from '../../domains/suggestedUsers/actions.types';
import { ThreadExtendedActivitySharesLoadFulfilledAction } from '../../domains/threadExtendedActivityShares/actions.types';
import { ThreadExtendedActivityTargetAudiencesAndNetworksLoadFulfilledAction } from '../../domains/threadExtendedActivityTargetAudiencesAndNetworks/actions.types';
import { ThreadExtendedActivityTopRepliesLoadFulfilledAction } from '../../domains/threadExtendedActivityTopReplies/actions.types';
import { ThreadListLoadFulfilledAction } from '../../domains/threadListLoad/actions.types';
import {
  ThreadLoadFulfilledAction,
  ThreadLoadNewerRepliesFulfilledAction,
  ThreadLoadOlderRepliesFulfilledAction,
} from '../../domains/threadLoad/actions.types';
import { ThreadSharesLoadFulfilledAction } from '../../domains/threadShares/actions.types';
import {
  TopLevelRepliesLoadInitialFulfilledAction,
  TopLevelRepliesLoadLastFulfilledAction,
  TopLevelRepliesLoadNextFulfilledAction,
  TopLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/topLevelReplies/actions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';
import { UserFollowedByLoadFulfilledAction } from '../../domains/userFollowedBy/actions.types';
import { UserFollowedUsersLoadFulfilledAction } from '../../domains/userFollowedUsers/actions.types';
import { UserHeaderLoadFulfilledAction } from '../../domains/userHeaderLoad/actions.types';
import { UserInsightsInfluenceLoadFulfilledAction } from '../../domains/userInsightsInfluences/actions.types';
import { ViewerTopRepliesLoadFulfilledAction } from '../../domains/viewerTopReplies/actions.types';

import { Networks } from './types';

export type NetworkAction =
  | CampaignTopContentCreatorsLoadFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | GroupMemberSearchLoadFulfilledAction
  | GroupSuggestedMembersLoadAction
  | GroupSuggestedMembersLoadMoreAction
  | ThreadLoadFulfilledAction
  | ThreadExtendedActivityTopRepliesLoadFulfilledAction
  | ThreadExtendedActivitySharesLoadFulfilledAction
  | ThreadSharesLoadFulfilledAction
  | ThreadLoadOlderRepliesFulfilledAction
  | ThreadLoadNewerRepliesFulfilledAction
  | ThreadPinToEventFeedFulfilledAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromEventFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction
  | ThreadListLoadFulfilledAction
  | PublishEventMessageFulfilledAction
  | PublishGroupMessageFulfilledAction
  | PublishUserMessageFulfilledAction
  | PublishUserPollMessageFulfilledAction
  | PublishUserPraiseMessageFulfilledAction
  | PublishDirectMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | PublishTeamsMeetingMessageFulfilledAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | SessionLoadCurrentUserFulfilledAction
  | MarkAllNotificationsAsSeenFulfilledAction
  | MessageReactionsLoadFulfilledAction
  | NotificationLoadMoreFulfilledAction
  | NestedThreadLoadFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | NetworkTopAnnouncementsLoadFulfilledAction
  | NetworkTopThreadStartersLoadAction
  | TopLevelRepliesLoadInitialFulfilledAction
  | TopLevelRepliesLoadLastFulfilledAction
  | TopLevelRepliesLoadPreviousFulfilledAction
  | TopLevelRepliesLoadNextFulfilledAction
  | ThreadExtendedActivityTargetAudiencesAndNetworksLoadFulfilledAction
  | ViewerTopRepliesLoadFulfilledAction
  | SecondLevelRepliesLoadPreviousFulfilledAction
  | SecondLevelRepliesLoadNextFulfilledAction
  | RecommendedGroupsLoadFulfilledAction
  | RecommendedGroupsLoadMoreFulfilledAction
  | SuggestedActionsLoadFulfilledAction
  | FirstRunSuggestedGroupsLoadFulfilledAction
  | SuggestedGroupsLoadFulfilledAction
  | SuggestedGroupsLoadMoreFulfilledAction
  | SuggestedLeadersLoadFulfilledAction
  | SuggestedLeadersLoadMoreFulfilledAction
  | SuggestedUsersLoadFulfilledAction
  | SecondLevelRepliesLoadLastFulfilledAction
  | UserFollowedByLoadFulfilledAction
  | UserFollowedUsersLoadFulfilledAction
  | CreateEventFulfilledAction
  | EditEventFulfilledAction
  | EventLoadByBroadcastIdFulfilledAction
  | GroupSidebarLoadFulfilledAction
  | GroupsMembersLoadFulfilledAction
  | UserHeaderLoadFulfilledAction
  | UserInsightsInfluenceLoadFulfilledAction
  | LiveEventLoadByGroupIdFulfilledAction
  | PublishUserMomentMessageFulfilledAction
  | PublishEditMessageFulfilledAction
  | TypeaheadFulfilledAction
  | UserConnectedLeadersListLoadFulfilledAction
  | UserFollowedLeadersListLoadFulfilledAction
  | UserFollowedLeadersListLoadMoreFulfilledAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserDirectAudienceLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction
  | LeaderLoadFulfilledAction
  | UserDirectAudienceLoadMoreFulfilledAction
  | SuggestedMyLeaderGroupsLoadFulfilledAction
  | CampaignTopThreadsLoadFulfilledAction
  | EmployeesTopThreadsLoadFulfilledAction
  | OfficialGroupsLoadFulfilledAction
  | OfficialGroupsLoadMoreFulfilledAction
  | NetworkTopThreadsLoadFulfilledAction;

const initialState: Networks = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

// eslint-disable-next-line max-lines-per-function
const reducer: Reducer<Networks, NetworkAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'GROUP_MEMBER_SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'GROUP_SUGGESTED_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'GROUP_SUGGESTED_MEMBERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.LOAD_NEWER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.LOAD_OLDER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.PIN_TO_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.UNPIN_FROM_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD_EXTENDED_ACTIVITY_TARGET_AUDIENCES_AND_NETWORKS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_TEAMS_MEETING_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'MESSAGE_REACTIONS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SESSION.LOAD_CURRENT_USER_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NETWORK_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'TOP_LEVEL_REPLIES.LOAD_INITIAL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'TOP_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'TOP_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'TOP_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SECOND_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SECOND_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'RECOMMENDED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'RECOMMENDED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_ACTION.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FRE_SUGGESTED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SECOND_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_FOLLOWED_BY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_FOLLOWED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'CREATE_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'EDIT_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'EVENT.LOAD_BY_BROADCAST_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'GROUPS_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_USER_MOMENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'CONNECTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'FOLLOWED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_DIRECT_AUDIENCE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'USER_DIRECT_AUDIENCE.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'OFFICIAL_GROUPS.LOAD_FULFILLED':
    case 'OFFICIAL_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'LEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    case 'VIEWER_TOP_REPLIES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networks);
    default:
      return state;
  }
};

export default reducer;
